import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";

import { RemoteGatewayFactory } from "../../gateways/remote-gateway-factory";
import { environment } from "src/environments/environment";
import { Url } from "../../models/domains/urls/url";
import { first } from "rxjs/operators";

@Injectable()
export class DrugstoreTestsRepository {
  constructor(private remoteGatewayFactory: RemoteGatewayFactory, private http: HttpClient) {}

  public async getToken() {
    const headers = { "content-type": "application/x-www-form-urlencoded" };
    const body = environment.pdvTokenBodyRequest;
    try {
      const data: any = await this.http.post(environment.pdvTokenUrl, body, { headers }).toPromise();
      return data.access_token;
    } catch (error) {
      console.log(error);
      return error;
    }
  }
}
